/** Canonical Me PWA install identity — keep in sync with public/me-manifest.json */
export const ME_PWA_MANIFEST_PATH = '/me-manifest.json';
export const ME_PWA_ID = 'apt-me-pwa';
export const ME_PWA_NAME = 'My APT';
export const ME_PWA_SHORT_NAME = 'My APT';
export const ME_PWA_START_URL = '/me/';
export const ME_PWA_SCOPE = '/me/';

/** Colored APT mark on transparent alpha (not the white icon-only raster). */
export const ME_PWA_APPLE_TOUCH_ICON = '/icons/icon-128x128-transparent.png';

export const ME_PWA_MANIFEST_ICONS = [
  {
    src: '/icons/icon-128x128-transparent.png',
    sizes: '128x128',
    type: 'image/png',
    purpose: 'any',
  },
  {
    src: '/icons/icon-128x128-transparent.png',
    sizes: '192x192',
    type: 'image/png',
    purpose: 'any',
  },
  {
    src: '/icons/icon-128x128-transparent.png',
    sizes: '512x512',
    type: 'image/png',
    purpose: 'any',
  },
] as const;

/** True for apex `/me` routes and legacy `me.*` hosts. */
export function isMePwaSurface(pathname: string, hostname: string): boolean {
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  if (normalizedPath === '/me' || normalizedPath.startsWith('/me/')) {
    return true;
  }
  const primaryLabel = hostname.split('.')[0]?.toLowerCase() ?? '';
  return primaryLabel === 'me';
}
